import React, { useEffect, useState } from 'react';
import './Main.css';
import Sidebar from '../Sidebar/Sidebar';
import Cart from '../Cart/Cart';
import Swal from 'sweetalert2'

const Main = () => {
    const [exercises, setExercises] = useState([]);
    const [cart, setCart] = useState([]);
    const [timeRequired, setTimeRequired] = useState(0);
    // const [breakTime, setBreakTime] = useState(0);

    useEffect(() => {
        fetch('./data.json')
            .then(res => res.json())
            .then(data => setExercises(data))
    }, []);

    const handleTimeRequired = (exercise) => {
        const newTimeRequired = cart.reduce((total, exercise) => total + exercise.reqTime, 0);
        setTimeRequired(newTimeRequired);
        console.log('button Clicked: ' + exercise.reqTime)
        const exerciseTime = document.getElementById('exercise-time');
        const newExerciseTime = exerciseTime.innerText;
        exerciseTime.innerText = parseInt(newExerciseTime) + exercise.reqTime;
    }

    const handleBreakTime = () => {
        const breakTime = document.getElementById('break-time');
        const newBreakTime = breakTime.innerText;
        breakTime.innerText = parseInt(newBreakTime) + 10;
        localStorage.setItem('breakTime', newBreakTime);
        console.log("Break Time: " + newBreakTime);

    }

    // const getLocalStorageData = () => {
    //     const getBreakTime = localStorage.getItem('breakTime');
    //     setBreakTime(getBreakTime);
    // };
    // getLocalStorageData();

    return (
        <div className='container'>
            <div className="row">
                <div className="col-md-9 d-flex flex-column">
                    <div className="row">
                        {
                            exercises.slice(0, 12).map(exercise => (<Cart
                                key={exercise.id}
                                exercise={exercise}
                                handleTimeRequired={handleTimeRequired}
                            ></Cart>
                            ))
                        }
                    </div>
                </div>
                <div className="col-md-3">
                    <Sidebar
                        timeRequired={timeRequired}
                        key={timeRequired}
                        handleBreakTime={handleBreakTime}
                    ></Sidebar>
                </div>
            </div>
        </div>
    );
};

export default Main;